import { __assign } from "tslib";
import React from 'react';
import { ThemeOverride, ThemeOptions, } from '@wix/da-react-context/pkg/ThemeContext';
import VerificationResent from './VerificationResent';
import VerificationNeeded from './VerificationNeeded';
export var VerificationReminder = function (_a) {
    var email = _a.email, isUnverified = _a.isUnverified, resendEmail = _a.resendEmail, isEmailChangeInProgress = _a.isEmailChangeInProgress, isResendInProgress = _a.isResendInProgress, isSendingDone = _a.isSendingDone, hideChangeEmail = _a.hideChangeEmail;
    return (React.createElement(ThemeOverride, { theme: ThemeOptions.LIGHT }, isSendingDone ? (React.createElement(VerificationResent, { email: email })) : (React.createElement(VerificationNeeded, __assign({}, {
        email: email,
        isUnverified: isUnverified,
        resendEmail: resendEmail,
        isEmailChangeInProgress: isEmailChangeInProgress,
        isResendInProgress: isResendInProgress,
        hideChangeEmail: hideChangeEmail,
    })))));
};
VerificationReminder.displayName = 'VerificationReminder';
export default VerificationReminder;
//# sourceMappingURL=VerificationReminder.js.map